import React, {useEffect, useState} from "react";
import {useSelector} from "../../../shared-services/redux-tiny";
import BottomDrawer from "../../topLayer/bottomDrawer/BottomDrawer";
import CartInfoMessage from "../../cart/CartInfoMessage";
import CTAButton from "../../cart/CTAButton";

const CartPageCTAMobile = (props) => {
  const name = "CartPageCTAMobile";
  const {className = "", style} = props || {};
  const {bottomDrawer} = useSelector(state => state.topLayer);

  const [options, setOptions] = useState(null);

  useEffect(() => {
    if (bottomDrawer?.name === name && bottomDrawer?.options) {
      setOptions(bottomDrawer.options);
    }

    return () => {
      setOptions(null);
    };
  }, [bottomDrawer]);

  return <BottomDrawer name={name}>
    {options?.currentCart && <div
      className={`
        full-width
        padding-10
        background-color-white
      `}
      style={{borderTop: "2px solid #F2F2F2"}}
    >
      <div
        className={`
          info-mobile
          justify-content-center
          align-items-center
          margin-bottom-15
          ${className}
        `}
        style={style}
      >
        <CartInfoMessage {...options} layout={"mobile"}/>
      </div>
      <CTAButton {...options} className="margin-bottom-15"/>
    </div>}
  </BottomDrawer>;
};

export default CartPageCTAMobile;
